import _definePage_default_0 from '/tmp/build_ace5d1d1/src/pages/index.vue?definePage&vue'
import { _mergeRouteRecord } from 'unplugin-vue-router/runtime'
import _definePage_default_2 from '/tmp/build_ace5d1d1/src/pages/[...path].vue?definePage&vue'
import _definePage_default_3 from '/tmp/build_ace5d1d1/src/pages/admin-view.vue?definePage&vue'
import _definePage_default_4 from '/tmp/build_ace5d1d1/src/pages/billing-history.vue?definePage&vue'
import _definePage_default_5 from '/tmp/build_ace5d1d1/src/pages/company-settings.vue?definePage&vue'
import _definePage_default_6 from '/tmp/build_ace5d1d1/src/pages/contract/[contractId].vue?definePage&vue'
import _definePage_default_7 from '/tmp/build_ace5d1d1/src/pages/contracts/[[folderId]].vue?definePage&vue'
import _definePage_default_8 from '/tmp/build_ace5d1d1/src/pages/hinnasto.vue?definePage&vue'
import _definePage_default_9 from '/tmp/build_ace5d1d1/src/pages/kontakti.vue?definePage&vue'
import _definePage_default_10 from '/tmp/build_ace5d1d1/src/pages/magic-link/[hash].vue?definePage&vue'
import _definePage_default_11 from '/tmp/build_ace5d1d1/src/pages/sahkoinen-allekirjoitus.vue?definePage&vue'
import _definePage_default_12 from '/tmp/build_ace5d1d1/src/pages/sahkoinen-allekirjoitus-turvallisuus.vue?definePage&vue'
import _definePage_default_13 from '/tmp/build_ace5d1d1/src/pages/sahkoinen-allekirjoitus-yrityksille.vue?definePage&vue'
import _definePage_default_14 from '/tmp/build_ace5d1d1/src/pages/templates/management.vue?definePage&vue'
import _definePage_default_15 from '/tmp/build_ace5d1d1/src/pages/tyosopimuksen-sahkoinen-allekirjoitus.vue?definePage&vue'
import _definePage_default_16 from '/tmp/build_ace5d1d1/src/pages/ukk.vue?definePage&vue'
import _definePage_default_17 from '/tmp/build_ace5d1d1/src/pages/verify/[hash].vue?definePage&vue'
import _definePage_default_18 from '/tmp/build_ace5d1d1/src/pages/vuokrasopimuksen-sahkoinen-allekirjoitus.vue?definePage&vue'

export const routes = [
  _mergeRouteRecord(
  {
    path: '/',
    name: 'Login',
    component: () => import('/tmp/build_ace5d1d1/src/pages/index.vue'),
    /* no children */
  },
  _definePage_default_0
  ),
  _mergeRouteRecord(
  {
    path: '/:path(.*)',
    name: '404',
    component: () => import('/tmp/build_ace5d1d1/src/pages/[...path].vue'),
    /* no children */
  },
  _definePage_default_2
  ),
  _mergeRouteRecord(
  {
    path: '/admin-view',
    name: 'AdminView',
    component: () => import('/tmp/build_ace5d1d1/src/pages/admin-view.vue'),
    /* no children */
  },
  _definePage_default_3
  ),
  _mergeRouteRecord(
  {
    path: '/billing-history',
    name: 'BillingHistory',
    component: () => import('/tmp/build_ace5d1d1/src/pages/billing-history.vue'),
    /* no children */
  },
  _definePage_default_4
  ),
  _mergeRouteRecord(
  {
    path: '/company-settings',
    name: 'CompanySettings',
    component: () => import('/tmp/build_ace5d1d1/src/pages/company-settings.vue'),
    /* no children */
  },
  _definePage_default_5
  ),
  {
    path: '/contract',
    /* internal name: '/contract' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: ':contractId',
        name: 'Contract',
        component: () => import('/tmp/build_ace5d1d1/src/pages/contract/[contractId].vue'),
        /* no children */
      },
  _definePage_default_6
  )
    ],
  },
  {
    path: '/contracts',
    /* internal name: '/contracts' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: ':folderId?',
        name: 'Contracts',
        component: () => import('/tmp/build_ace5d1d1/src/pages/contracts/[[folderId]].vue'),
        /* no children */
      },
  _definePage_default_7
  )
    ],
  },
  _mergeRouteRecord(
  {
    path: '/hinnasto',
    name: '/hinnasto',
    component: () => import('/tmp/build_ace5d1d1/src/pages/hinnasto.vue'),
    /* no children */
  },
  _definePage_default_8
  ),
  _mergeRouteRecord(
  {
    path: '/kontakti',
    name: '/kontakti',
    component: () => import('/tmp/build_ace5d1d1/src/pages/kontakti.vue'),
    /* no children */
  },
  _definePage_default_9
  ),
  {
    path: '/magic-link',
    /* internal name: '/magic-link' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: ':hash',
        name: 'MagicLink',
        component: () => import('/tmp/build_ace5d1d1/src/pages/magic-link/[hash].vue'),
        /* no children */
      },
  _definePage_default_10
  )
    ],
  },
  {
    path: '/nets',
    name: '/nets',
    component: () => import('/tmp/build_ace5d1d1/src/pages/nets.vue'),
    /* no children */
  },
  _mergeRouteRecord(
  {
    path: '/sahkoinen-allekirjoitus',
    name: '/sahkoinen-allekirjoitus',
    component: () => import('/tmp/build_ace5d1d1/src/pages/sahkoinen-allekirjoitus.vue'),
    /* no children */
  },
  _definePage_default_11
  ),
  _mergeRouteRecord(
  {
    path: '/sahkoinen-allekirjoitus-turvallisuus',
    name: '/sahkoinen-allekirjoitus-turvallisuus',
    component: () => import('/tmp/build_ace5d1d1/src/pages/sahkoinen-allekirjoitus-turvallisuus.vue'),
    /* no children */
  },
  _definePage_default_12
  ),
  _mergeRouteRecord(
  {
    path: '/sahkoinen-allekirjoitus-yrityksille',
    name: '/sahkoinen-allekirjoitus-yrityksille',
    component: () => import('/tmp/build_ace5d1d1/src/pages/sahkoinen-allekirjoitus-yrityksille.vue'),
    /* no children */
  },
  _definePage_default_13
  ),
  {
    path: '/templates',
    /* internal name: '/templates' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: 'management',
        name: 'TemplateManagement',
        component: () => import('/tmp/build_ace5d1d1/src/pages/templates/management.vue'),
        /* no children */
      },
  _definePage_default_14
  )
    ],
  },
  _mergeRouteRecord(
  {
    path: '/tyosopimuksen-sahkoinen-allekirjoitus',
    name: '/tyosopimuksen-sahkoinen-allekirjoitus',
    component: () => import('/tmp/build_ace5d1d1/src/pages/tyosopimuksen-sahkoinen-allekirjoitus.vue'),
    /* no children */
  },
  _definePage_default_15
  ),
  _mergeRouteRecord(
  {
    path: '/ukk',
    name: '/ukk',
    component: () => import('/tmp/build_ace5d1d1/src/pages/ukk.vue'),
    /* no children */
  },
  _definePage_default_16
  ),
  {
    path: '/verify',
    /* internal name: '/verify' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: ':hash',
        name: 'Verify',
        component: () => import('/tmp/build_ace5d1d1/src/pages/verify/[hash].vue'),
        /* no children */
      },
  _definePage_default_17
  )
    ],
  },
  _mergeRouteRecord(
  {
    path: '/vuokrasopimuksen-sahkoinen-allekirjoitus',
    name: '/vuokrasopimuksen-sahkoinen-allekirjoitus',
    component: () => import('/tmp/build_ace5d1d1/src/pages/vuokrasopimuksen-sahkoinen-allekirjoitus.vue'),
    /* no children */
  },
  _definePage_default_18
  )
]
